import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

const vkey = (window.navigator as any)?.virtualKeyboard;
if (vkey?.overlaysContent) {
  vkey.overlaysContent = true;
}

(window as any).bootstrapAngularApp = function(): void {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .then(ref => {
      (window as any).moduleRef = ref;

      const observer = new MutationObserver(() => {
        const appRootExists = document.querySelector('dt-credit-app-root');
        if (!appRootExists && (window as any).moduleRef) {
          (window as any).moduleRef.destroy();
          (window as any).moduleRef = null;
          observer.disconnect();
          console.log('Angular app unmounted because <dt-credit-app-root> was removed.');
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });

      console.log('Angular app mounted.');
    })
    .catch(err => console.error(err));
};

(window as any).bootstrapAngularApp();
